// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__3u3hB","label":"TextInput_label__22MyK"};